var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-gauge-item",attrs:{"id":this.gaugeId}})
}
var staticRenderFns = []

export { render, staticRenderFns }